import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { Observable } from "rxjs";
import {
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ReportConstants } from "../ReportConstants";
import { MatDialog } from "@angular/material/dialog";
import { ExcelExportService } from "../../../services/excel-export.service";
import { ErrorHandlerDialogComponent } from "../../error-handler-dialog/error-handler-dialog.component";
import { ReaderService } from "../../../services/reader.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { SelectionSortComponent } from "../../base-components/selection-sort/selection-sort.component";
import { isDate } from "ngx-bootstrap/chronos";
import * as _ from "lodash";

interface Menu {
  model: UntypedFormControl;
  availableOptions: any[];
  selectedOptions: any[] | string;
}

@Component({
    selector: "app-competitive-activity-landscape",
    templateUrl: "./competitive-activity-landscape.component.html",
    styleUrls: ["./competitive-activity-landscape.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompetitiveActivityLandscapeComponent
  extends SelectionSortComponent
  implements OnInit
{
  vehicleRolloutList: any = [];
  filteredVehicleRolloutList: any = [];
  cycleOptions: string[] = [
    "New",
    "Add",
    "MCM*",
    "New*",
    "Add*",
    "Major*",
    "Major",
    "Cancel",
    "Drop",
  ];
  columnList: any[] = [];
  segDataList: any[] = [];
  isLoading = false;
  displayTable = false;
  selectAllReportFilters = false;
  constants: ReportConstants = new ReportConstants();
  addNewEntries: any = [];
  majorEntries: any = [];
  dropEntries: any = [];
  cancelEntries: any = [];
  defaultBrand: any = [];
  defaultModel: any = [];
  defaultSegment: any = [];
  cplDisplayYear = "cplDisplayYear";
  cplStartDate = "cplStartDate";
  cplEndDate = "cplEndDate";
  cplOem = "cplOem";
  cplBrand = "cplBrand";
  cplModel = "cplModel";
  cplSegment = "cplSegment";
  cplPropulsion = "cplPropulsion";
  cplMarket = "cplMarket";
  cplBrandAvailableOptions = "cplBrandAvailableOptions";
  cplModelAvailableOptions = "cplModelAvailableOptions";
  cplSegmentAvailableOptions = "cplSegmentAvailableOptions";

  displayYears: Menu = {
    model: new FormControl({ value: "", disabled: true }, Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  changedStartDate = false;
  changedEndDate = false;
  changedDisplayYear = false;
  changedOem = false;
  changedBrand = false;
  changedNameplate = false;
  changedSegment = false;
  changedPropulsionType = false;
  changedMarket = false;

  start: Date;
  end: Date;
  time: number;

  checked = new FormControl<boolean>(false);

  startDate: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  endDate = new FormControl(new Date(), Validators.required);

  oem: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  brand: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  model: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  segment: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  propulsion: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  market: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  changeTypes: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  changeSegments: Menu = {
    model: new FormControl("", Validators.required),
    availableOptions: [],
    selectedOptions: [],
  };

  showIcons = new FormControl<boolean>(false);

  formGroup = new FormGroup({
    checked: this.checked,
    startDate: this.startDate.model,
    endDate: this.endDate,
    displayYears: this.displayYears.model,
    oem: this.oem.model,
    brand: this.brand.model,
    model: this.model.model,
    segment: this.segment.model,
    propulsion: this.propulsion.model,
    market: this.market.model,
    showIcons: this.showIcons,
  });

  changeDetailsForm = new FormGroup({
    changeTypes: this.changeTypes.model,
    changeSegments: this.changeSegments.model,
  });

  constructor(
    public readonly dialog: MatDialog,
    public readonly cd: ChangeDetectorRef,
    private readonly http: HttpClient,
    private readonly excelExport: ExcelExportService,
    private readonly readerService: ReaderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.beginLoading();
    this.handleMenuItems();
    this.setFilterOptionFromSession();
    this.endLoading();
  }

  getHeight() {
    if (document.getElementById("nameplate")) {
      return document.getElementById("nameplate").offsetTop - 55;
    }
  }

  generateReport() {
    if (this.searchCriteriaIsValid()) {
      this.beginLoading();
      const fromDate = this.startDate.selectedOptions
        .toLocaleString()
        .substring(
          0,
          this.startDate.selectedOptions.toLocaleString().indexOf(",")
        )
        .split("/")
        .join("-");
      const toDate = this.parseDate(this.endDate);

      const url = environment.serviceURL + "/competitiveLandscape";
      this.generateReportHelper(
        url,
        fromDate,
        toDate,
        this.displayYears.selectedOptions,
        this.oem.selectedOptions,
        this.brand.selectedOptions,
        this.model.selectedOptions,
        this.segment.selectedOptions,
        this.propulsion.selectedOptions,
        this.market.selectedOptions
      );
    } else {
      this.dialog.open(ErrorHandlerDialogComponent, {
        data: { message: "Please specify search criteria." },
      });
    }
  }

  public generateReportHelper(
    url: string,
    fromDate,
    toDate,
    displayYears,
    oem,
    brand,
    model,
    segment,
    propulsion,
    market
  ): void {
    this.http
      .post<any>(url, {
        fromDate,
        toDate,
        displayYears,
        oem,
        brand,
        model,
        segment,
        propulsion,
        market,
      })
      .subscribe({
        next: (x: any) => {
          this.handleVehicleRolloutReportData(x);
        },
        error: (err: any) => {
          this.dialog.open(ErrorHandlerDialogComponent, {
            data: {
              message: err.error == null ? err.message : err.error.message,
            },
          });
          this.endLoading();
        },
        complete: () => {
          this.endLoading();
        },
      });
  }

  public handleVehicleRolloutReportData(data): void {
    const segData = data.globalSegments[0];
    const vehData = data.vehicles;
    const segDataArr = [];
    this.populateChangeDetailsFilters(data);

    this.start = new Date();
    Object.keys(segData).map((key) => {
      segDataArr.push(segData[key]);
    });
    this.end = new Date();
    this.time = (this.end.getTime() - this.start.getTime()) / 1000;

    if (vehData.length > 0) {
      const yearRange = this.displayYears.selectedOptions;
      this.start = new Date();
      let tempData = vehData.filter((record) => record.s_cycles != null);
      this.end = new Date();
      this.time = (this.end.getTime() - this.start.getTime()) / 1000;

      this.start = new Date();
      tempData = tempData.filter(
        (record) =>
          record.s_cycles &&
          Object.keys(record.s_cycles).some((r) => yearRange.indexOf(r) !== -1)
      );
      this.end = new Date();
      this.time = (this.end.getTime() - this.start.getTime()) / 1000;

      this.segDataList = segDataArr;
      this.start = new Date();
      this.segDataList.sort((a, b) => a.localeCompare(b));
      this.end = new Date();
      this.time = (this.end.getTime() - this.start.getTime()) / 1000;

      this.displayTable = true;
      this.vehicleRolloutList = tempData;
      this.columnList = ["Engineering Cycle"].concat(yearRange);

      this.setupDataforChangeDetailsTable();
      this.prepareEntryArrays();
    } else {
      this.clearReport();
      this.dialog.open(ErrorHandlerDialogComponent, {
        data: {
          message:
            "There are no entries matching the selected report criteria.",
        },
      });
    }
  }

  public prepareEntryArrays(): void {
    this.start = new Date();
    for (const s of this.segDataList) {
      const segIndex = this.segDataList.indexOf(s);
      this.addNewEntries[segIndex] = [];
      this.majorEntries[segIndex] = [];
      this.dropEntries[segIndex] = [];
      this.cancelEntries[segIndex] = [];
      for (let i = 1; i <= this.displayYears.selectedOptions.length; i++) {
        this.addNewEntries[segIndex].push(
          this.getCellText(
            s,
            ["New", "Add", "MCM*", "New*", "Add*", "Major*"],
            i
          )
        );
        this.majorEntries[segIndex].push(this.getCellText(s, ["Major"], i));
        this.dropEntries[segIndex].push(this.getCellText(s, ["Drop"], i));
        this.cancelEntries[segIndex].push(this.getCellText(s, ["Cancel"], i));
      }
    }

    this.end = new Date();
    this.time = (this.end.getTime() - this.start.getTime()) / 1000;
  }

  public getVehicleNameplate(vehicle): string {
    let vehicleCellText = "";
    if (vehicle.brand != null) {
      vehicleCellText = vehicle.brand + " ";
    }
    if (vehicle.s_globalnameplate != null) {
      vehicleCellText += vehicle.s_globalnameplate + " ";
    }
    if (vehicle.s_bodystyle != null) {
      vehicleCellText += vehicle.s_bodystyle + " ";
    }
    if (vehicle.PROPULSION !== "ICE" && vehicle.PROPULSION != null) {
      vehicleCellText += " - " + vehicle.PROPULSION + " ";
    }

    return vehicleCellText.slice(0, -1);
  }

  public handleChangeFlag(vehicle, arr: any[]): any[] {
    if (vehicle.FLAG === "NEWDROP") {
      arr.push("DROP");
    } else {
      arr.push(vehicle.FLAG);
    }
    return arr;
  }

  public handleCancelDetails(vehicle, arr: any[]): any[] {
    if (vehicle.o_launchprobability === vehicle.s_launchprobability) {
      arr.push(
        vehicle.o_globalnameplate == null
          ? ""
          : vehicle.o_globalnameplate + " -> " + vehicle.s_globalnameplate
      );
    } else {
      arr.push(
        vehicle.o_launchprobability + " -> " + vehicle.s_launchprobability
      );
    }
    return arr;
  }

  public handleOtherDropDetails(vehicle, arr: any[]): any[] {
    if (vehicle.o_cycles == null) {
      arr.push(JSON.stringify(vehicle.s_cycles));
    } else {
      arr.push(
        JSON.stringify(vehicle.o_cycles) +
          " -> " +
          JSON.stringify(vehicle.s_cycles)
      );
    }
    return arr;
  }

  public handleChangeDetails(vehicle, arr: any[]): any[] {
    switch (vehicle.FLAG as string) {
      case "NEWDROP":
        arr.push(JSON.stringify(vehicle.s_cycles));
        break;
      case "NEW":
        arr.push("New Vehicle");
        break;
      case "SEGMENT":
        arr.push(vehicle.o_globalsegment + " -> " + vehicle.s_globalsegment);
        break;
      case "LIFECYCLE":
        const oCycles =
          vehicle.o_cycles == null
            ? "Incomplete Lifecycle data"
            : vehicle.o_cycles;
        arr.push(
          JSON.stringify(oCycles) + " -> " + JSON.stringify(vehicle.s_cycles)
        );
        break;
      case "CANCEL":
        arr = this.handleCancelDetails(vehicle, arr);
        break;
      case "NAMEPLATE": {
        if (vehicle.o_globalnameplate === null) {
          arr.push("TBD -> " + vehicle.s_globalnameplate);
        } else {
          arr.push(
            vehicle.o_globalnameplate + " -> " + vehicle.s_globalnameplate
          );
        }
        break;
      }
      case "OTHER":
      case "DROP":
        arr = this.handleOtherDropDetails(vehicle, arr);
        break;
      default:
        arr.push("");
    }
    return arr;
  }

  public getChangeDetail(row): any[] {
    let arr = [];
    const vehicle = this.filteredVehicleRolloutList[row];

    arr.push(vehicle.s_globalsegment);
    arr.push(this.getVehicleNameplate(vehicle));

    arr = this.handleChangeFlag(vehicle, arr);
    arr = this.handleChangeDetails(vehicle, arr);

    return arr;
  }

  public getColor(row): string {
    const vehicle = this.filteredVehicleRolloutList[row];
    switch (vehicle.FLAG as string) {
      case "NEW":
      case "NEWDROP":
      case "DROP":
        return "red";
      case "SEGMENT":
        return "green";
      case "LIFECYCLE":
        return "blue";
      case "NAMEPLATE":
        return "#F27D07";
      default:
        return "black";
    }
  }

  public getCellText(segment, row, index: number): any[] {
    const year = Number(this.displayYears.selectedOptions[0]) + index - 1;
    let cellEntriesTemp = [];
    this.vehicleRolloutList.forEach((vehicle) => {
      cellEntriesTemp = this.checkSegment(
        cellEntriesTemp,
        row,
        vehicle,
        segment,
        year
      );
    });
    return cellEntriesTemp;
  }

  public checkSegment(
    cellEntriesTemp: any[],
    row,
    vehicle,
    segment,
    year: number
  ): any[] {
    if (
      vehicle.s_globalsegment === segment ||
      (vehicle.FLAG === "SEGMENT" && vehicle.o_globalsegment === segment)
    ) {
      Object.entries(vehicle.s_cycles).forEach((cycle) => {
        if (cycle[0] === year.toString()) {
          if (row.includes(cycle[1])) {
            const cellTextObj = this.buildCellText(vehicle, segment, cycle[0]);
            cellEntriesTemp.push(cellTextObj);
          }
        }
      });
    }
    return cellEntriesTemp;
  }

  public buildCellText(vehicle, segment, year: string): any {
    let color: string;
    let icon: string;
    let style: string;
    switch (vehicle.FLAG) {
      case "NEW":
      case "NEWDROP":
      case "DROP":
        color = "red";
        icon = "star";
        break;
      case "SEGMENT":
        color = "green";
        icon = "drive_eta";
        style = vehicle.o_globalsegment === segment ? "line-through" : "";
        break;
      case "LIFECYCLE":
        color = "blue";
        icon = "access_time";
        break;
      case "NAMEPLATE":
        color = "#F27D07";
        icon = "edit";
        break;
      default:
        color = "black";
        icon = null;
        break;
    }
    return {
      text: this.getVehicleNameplate(vehicle),
      year,
      color,
      icon,
      style,
    };
  }

  public beginLoading(): void {
    this.isLoading = true;
  }

  public endLoading(): void {
    this.isLoading = false;
  }

  public onChangeDisplayYears(newValue: string[]): void {
    this.displayYears.selectedOptions = newValue;
    if (!this.isLoading) {
      this.selectAllReportFilters = false;
    }
    this.setSession(
      this.cplDisplayYear,
      JSON.stringify(this.displayYears.selectedOptions)
    );
  }

  public onChangeStartDate(newValue: string): void {
    this.changedStartDate = true;
    this.startDate.selectedOptions = newValue;

    if (!this.isLoading) {
      this.selectAllReportFilters = false;
    }
    if (
      !this.startDate.selectedOptions ||
      this.startDate.selectedOptions.length === 0
    ) {
      this.selectAllReportFilters = false;
      this.formGroup.get("displayYears").disable();
    } else {
      this.setAvailableYearOptions();
      this.selectDefaultYearRange();
      this.formGroup.get("displayYears").enable();
    }
    this.setSession(this.cplStartDate, newValue);
    this.setSession(
      this.cplDisplayYear,
      JSON.stringify(this.displayYears.selectedOptions)
    );
    this.changedDisplayYear = true;
  }

  public onChangeEndDate(newValue: string): void {
    this.selectAllReportFilters = false;
    this.changedEndDate = true;
    this.setSession(this.cplEndDate, newValue);
  }

  public onChangeOem(newValue: string[]): void {
    this.oem.selectedOptions = newValue;
    if (!this.isLoading) {
      this.formGroup.get("checked").setValue(false);
      if (this.oem.selectedOptions && this.oem.selectedOptions.length > 0) {
        this.filterBrandsAndBelow(newValue);
      } else {
        this.filterBrandsAndBelow(this.oem.availableOptions);
      }
    }
    this.setSession(this.cplOem, JSON.stringify(this.oem.selectedOptions));
    this.setSession(this.cplBrand, JSON.stringify([]));
    this.setSession(this.cplModel, JSON.stringify([]));
    this.setSession(this.cplSegment, JSON.stringify([]));
    this.changedOem = true;
  }

  public onChangeBrand(newValue: string[]): void {
    this.brand.selectedOptions = newValue;
    if (!this.isLoading) {
      if (this.brand.selectedOptions && this.brand.selectedOptions.length > 0) {
        this.filterNameplatesAndBelow(
          this.oem.selectedOptions as any[],
          this.brand.selectedOptions
        );
      } else {
        this.filterNameplatesAndBelow(
          this.oem.selectedOptions as any[],
          this.brand.availableOptions
        );
      }
    }
    this.setSession(this.cplBrand, JSON.stringify(this.brand.selectedOptions));
    this.setSession(this.cplModel, JSON.stringify([]));
    this.setSession(this.cplSegment, JSON.stringify([]));
    this.changedBrand = true;
  }

  public onChangeModel(newValue: string[]): void {
    this.model.selectedOptions = newValue;
    if (!this.isLoading) {
      this.formGroup.get("checked").setValue(false);
      if (this.model.selectedOptions && this.model.selectedOptions.length > 0) {
        this.formGroup.get("checked").setValue(false);
        this.filterSegmentsAndBelow(
          this.oem.selectedOptions as any[],
          this.brand.selectedOptions as any[],
          newValue
        );
      } else {
        this.filterSegmentsAndBelow(
          this.oem.selectedOptions as any[],
          this.brand.selectedOptions as any[],
          newValue
        );
      }
    }
    this.setSession(this.cplModel, JSON.stringify(this.model.selectedOptions));
    this.setSession(this.cplSegment, JSON.stringify([]));
    this.changedNameplate = true;
  }

  public onChangeSegment(newValue: string[]): void {
    if (!this.isLoading) {
      this.formGroup.get("checked").setValue(false);
      this.selectAllReportFilters = false;
    }
    this.segment.selectedOptions = newValue;
    this.setSession(
      this.cplSegment,
      JSON.stringify(this.segment.selectedOptions)
    );
    this.changedSegment = true;
  }

  public onChangePropulsion(newValue: string[]): void {
    if (!this.isLoading) {
      this.formGroup.get("checked").setValue(false);
      this.selectAllReportFilters = false;
    }
    this.propulsion.selectedOptions = newValue;
    this.setSession(
      this.cplPropulsion,
      JSON.stringify(this.propulsion.selectedOptions)
    );
    this.changedPropulsionType = true;
  }

  public onChangeMarket(newValue: string[]): void {
    this.market.selectedOptions = newValue;
    this.setSession(
      this.cplMarket,
      JSON.stringify(this.market.selectedOptions)
    );
    if (!this.isLoading) {
      this.selectAllReportFilters = false;
      this.formGroup.get("checked").setValue(false);
    }
    this.changedMarket = true;
  }

  public onChangeDetails(newValue: string[], type: string): void {
    if (type === "SEGMENT") {
      this.setChangeDetailsFilter(newValue, this.changeSegments);
    } else {
      this.setChangeDetailsFilter(newValue, this.changeTypes);
    }
    this.setupDataforChangeDetailsTable();
  }

  public filterBrandsAndBelow(oem: string[]): void {
    this.readerService.getActiveBrandForOem(oem).subscribe((brands) => {
      this.brand.selectedOptions = _.filter(this.brand.selectedOptions, (x) => {
        return brands.includes(x);
      });
      this.formGroup.controls["brand"].setValue(this.brand.selectedOptions, {
        onlySelf: true,
        emitEvent: false,
      });
      this.brand.availableOptions = brands;
      this.setSession(
        this.cplBrandAvailableOptions,
        JSON.stringify(this.brand.availableOptions)
      );
      this.changedBrand = false;
      this.filterNameplatesAndBelow(oem, brands);
    });
  }

  public filterNameplatesAndBelow(oem: string[], brands: any[]): void {
    this.readerService
      .getModelsForBrands(oem, brands)
      .subscribe((nameplates) => {
        this.model.selectedOptions = _.filter(
          this.model.selectedOptions,
          (x) => {
            return nameplates.includes(x);
          }
        );
        this.formGroup.controls["model"].setValue(this.model.selectedOptions, {
          onlySelf: true,
          emitEvent: false,
        });
        this.model.availableOptions = nameplates;
        this.setSession(
          this.cplModelAvailableOptions,
          JSON.stringify(this.model.availableOptions)
        );
        this.changedNameplate = false;
        this.filterSegmentsAndBelow(oem, brands, nameplates);
      });
    this.selectAllReportFilters = false;
  }

  public filterSegmentsAndBelow(
    oem: string[],
    brands: string[],
    nameplates: string[]
  ): void {
    this.readerService
      .getSegmentsForModels(oem, brands, nameplates)
      .subscribe((segments) => {
        this.segment.selectedOptions = _.filter(
          this.segment.selectedOptions,
          (x) => {
            return segments.includes(x);
          }
        );
        this.formGroup.controls["segment"].setValue(
          this.segment.selectedOptions,
          { onlySelf: true, emitEvent: false }
        );
        this.segment.availableOptions = segments;
        this.setSession(
          this.cplSegmentAvailableOptions,
          JSON.stringify(this.segment.availableOptions)
        );
        this.changedSegment = false;
      });
  }

  public exportToExcel(): void {
    if (this.searchCriteriaIsValid()) {
      this.beginLoading();

      const fromDate = this.startDate.selectedOptions
        .toLocaleString()
        .substring(
          0,
          this.startDate.selectedOptions.toLocaleString().indexOf(",")
        )
        .split("/")
        .join("-");
      const toDate = this.parseDate(this.endDate);

      const url = `${environment.serviceURL}/competitiveLandscapeExportToExcel`;

      this.exportToExcelHelper(
        url,
        fromDate,
        toDate,
        this.displayYears.selectedOptions,
        this.oem.selectedOptions,
        this.brand.selectedOptions,
        this.model.selectedOptions,
        this.segment.selectedOptions,
        this.propulsion.selectedOptions,
        this.market.selectedOptions
      );
    } else {
      this.dialog.open(ErrorHandlerDialogComponent, {
        data: { message: "Please specify search criteria." },
      });
    }
  }

  public exportToExcelHelper(
    url: string,
    fromDate: string,
    toDate: string,
    displayYears: any[] | string,
    oem: any[] | string,
    brand: any[] | string,
    model: any[] | string,
    segment: any[] | string,
    propulsion: any[] | string,
    market: any[] | string
  ): void {
    const headers = new HttpHeaders();
    headers["Content-Disposition"] = "attachment; filename=filename.pdf";
    this.http
      .post(
        url,
        {
          fromDate,
          toDate,
          displayYears,
          oem,
          brand,
          model,
          segment,
          propulsion,
          market,
        },
        {
          headers,
          responseType: "blob",
        }
      )
      .subscribe({
        next: (response: any) => {
          this.excelExport.exportToExcelFromServer(
            response,
            "CompetitiveActivityLandscapeReport"
          );
        },
        error: () => {
          this.dialog.open(ErrorHandlerDialogComponent, {
            data: { message: "Error occurred while creating excel file." },
          });
          this.endLoading();
        },
        complete: () => {
          this.endLoading();
          this.cd.detectChanges();
        },
      });
  }

  public clearFilters(): void {
    this.selectAllReportFilters = false;
    this.formGroup.get("checked").setValue(false);

    this.clearReport();
    this.displayYears.selectedOptions = [];
    this.displayYears.model.setValue([]);

    this.startDate.selectedOptions = [];
    this.startDate.model.setValue(null);

    this.endDate.setValue(new Date());

    this.oem.selectedOptions = null;
    this.oem.model.setValue([]);

    this.model.selectedOptions = null;
    this.model.model.setValue([]);

    this.brand.selectedOptions = null;
    this.brand.model.setValue([]);

    this.segment.selectedOptions = null;
    this.segment.model.setValue([]);

    this.propulsion.selectedOptions = null;
    this.propulsion.model.setValue([]);

    this.market.selectedOptions = null;
    this.market.model.setValue([]);

    this.changeSegments.selectedOptions = null;
    this.changeSegments.availableOptions = [];
    this.changeSegments.model.setValue([]);

    this.changeTypes.selectedOptions = null;
    this.changeTypes.availableOptions = [];
    this.changeTypes.model.setValue([]);

    this.selectAllReportFilters = false;

    this.changedStartDate = false;
    this.changedEndDate = false;
    this.changedOem = false;
    this.changedBrand = false;
    this.changedNameplate = false;
    this.changedSegment = false;
    this.changedPropulsionType = false;
    this.changedMarket = false;
    this.changedDisplayYear = false;
    this.handleMenuItems();
  }

  public handleMenuItems(): void {
    this.readerService.getVehicleOems().subscribe((x) => {
      this.oem.availableOptions = x;
      this.setFilterOptionFromSessionHelper(this.cplOem, this.oem);
    });
    this.readerService
      .getAllRecords("competitivePropulsions")
      .subscribe((x) => {
        this.propulsion.availableOptions = x;
        if (!sessionStorage.getItem(this.cplPropulsion)) {
          this.propulsion.selectedOptions = this.propulsion.availableOptions;
          this.propulsion.model.setValue(this.propulsion.selectedOptions, {
            onlySelf: true,
            emitEvent: false,
            emitModelToViewChange: true,
            emitViewToModelChange: false,
          });
        }
      });
    this.readerService.getRegions("bodystyle").subscribe({
      next: (x) => {
        const regionsTemp = [];
        x.forEach((region) => {
          const regionTemp = region.split(",")[1];
          if (regionTemp != "ELC") {
            regionsTemp.push(regionTemp);
          }
        });
        this.market.availableOptions = regionsTemp;
      },
      error: () => {},
      complete: () => {
        this.setAvailableYearOptions();
        this.updateMenuItem();
      },
    });
  }

  public updateMenuItem(): void {
    if (!(this.cplModelAvailableOptions in sessionStorage)) {
      this.readerService.getActiveModel().subscribe((x) => {
        this.model.availableOptions = x;
        this.model.availableOptions = this.sortSelectedOptions(
          this.model.availableOptions,
          this.model.availableOptions
        );
        this.defaultModel = this.model.availableOptions;
      });
    } else {
      this.model.availableOptions = JSON.parse(
        sessionStorage.getItem(this.cplModelAvailableOptions)
      );
    }

    if (!(this.cplBrandAvailableOptions in sessionStorage)) {
      this.readerService.getVehicleBrands().subscribe((x) => {
        this.brand.availableOptions = x;
        this.defaultBrand = this.brand.availableOptions;
      });
    } else {
      this.brand.availableOptions = JSON.parse(
        sessionStorage.getItem(this.cplBrandAvailableOptions)
      );
    }
    if (!(this.cplSegmentAvailableOptions in sessionStorage)) {
      this.readerService.getAvailableSegments().subscribe((x) => {
        this.segment.availableOptions = x;
        this.defaultSegment = this.segment.availableOptions;
      });
    } else {
      this.segment.availableOptions = JSON.parse(
        sessionStorage.getItem(this.cplSegmentAvailableOptions)
      );
    }
  }

  public searchCriteriaIsValid(): boolean {
    let result: boolean;
    if (
      this.displayYears.selectedOptions &&
      this.brand.selectedOptions &&
      this.model.selectedOptions &&
      this.segment.selectedOptions &&
      this.propulsion.selectedOptions &&
      this.startDate.selectedOptions &&
      this.market.selectedOptions
    ) {
      result = !(
        this.displayYears.selectedOptions.length === 0 ||
        this.brand.selectedOptions.length === 0 ||
        this.model.selectedOptions.length === 0 ||
        this.segment.selectedOptions.length === 0 ||
        this.propulsion.selectedOptions.length === 0 ||
        this.startDate.selectedOptions.length === 0 ||
        this.market.selectedOptions.length === 0
      );
    } else {
      result = false;
    }
    return result;
  }

  public setMenuItems(newValue: any[] | string, menu: Menu): void {
    menu.model.setValue(newValue, {
      onlySelf: true,
      emitEvent: true,
      emitModelToViewChange: false,
      emitViewToModelChange: false,
    });
  }

  public setChangeDetailsFilter(newValue: string[], menu: Menu): void {
    menu.selectedOptions = newValue;
    menu.model.setValue(newValue, {
      onlySelf: true,
      emitEvent: false,
      emitModelToViewChange: true,
      emitViewToModelChange: false,
    });
  }

  public setFilterOptionFromSession(): void {
    this.setFilterOptionFromSessionHelper2();
    this.setFilterOptionFromSessionHelper(this.cplStartDate, this.startDate);
    this.setFilterOptionFromSessionHelper(this.cplOem, this.oem);
    this.setFilterOptionFromSessionHelper(this.cplBrand, this.brand);
    this.setFilterOptionFromSessionHelper(this.cplModel, this.model);
    this.setFilterOptionFromSessionHelper(this.cplSegment, this.segment);
    this.setFilterOptionFromSessionHelper(this.cplMarket, this.market);
  }

  public setFilterOptionFromSessionHelper2(): void {
    if (sessionStorage.getItem(this.cplDisplayYear) !== null) {
      if (sessionStorage.getItem(this.cplDisplayYear).length > 2) {
        this.setFilterOptionFromSessionHelper(
          this.cplDisplayYear,
          this.displayYears
        );
        this.formGroup.get("displayYears").enable();
      }
    }

    if (sessionStorage.getItem(this.cplEndDate) !== null) {
      this.endDate.setValue(
        new Date(sessionStorage.getItem(this.cplEndDate)) as any
      );
      this.changedEndDate = true;
    }

    if (sessionStorage.getItem(this.cplPropulsion) !== null) {
      if (sessionStorage.getItem(this.cplPropulsion).length > 2) {
        this.setFilterOptionFromSessionHelper(
          this.cplPropulsion,
          this.propulsion
        );
      }
    }
  }

  public setFilterOptionFromSessionHelper(
    filterName: string,
    menu: Menu
  ): void {
    if (sessionStorage.getItem(filterName) !== null) {
      if (filterName === this.cplStartDate) {
        if (sessionStorage.getItem(this.cplStartDate) !== "null") {
          this.startDate.selectedOptions = new Date(
            sessionStorage.getItem(this.cplStartDate)
          ) as any;
        }
      } else {
        menu.selectedOptions = JSON.parse(sessionStorage.getItem(filterName));
        menu.availableOptions = this.sortSelectedOptions(
          menu.availableOptions,
          menu.selectedOptions
        );
      }
      this.setFilterValue(menu);
    }
  }

  public setFilterValue(menu: Menu): void {
    this.setMenuItems(menu.selectedOptions, menu);
  }

  public setSession(cplFilter: string, s: string): void {
    sessionStorage.setItem(cplFilter, s);
  }

  public clearReport(): void {
    this.displayTable = false;
    this.vehicleRolloutList = [];
    this.columnList = [];
  }

  public selectAllForChild(child): Promise<void> {
    return Promise.resolve(child.selectAllChange());
  }

  async selectAllMenuOptions(): Promise<void> {
    this.beginLoading();
    this.oem.selectedOptions = this.oem.availableOptions;
    this.formGroup.controls["oem"].setValue(this.oem.availableOptions, {
      onlySelf: true,
      emitEvent: false,
    });

    this.brand.selectedOptions = this.brand.availableOptions;
    this.formGroup.controls["brand"].setValue(this.brand.availableOptions, {
      onlySelf: true,
      emitEvent: false,
    });

    this.model.selectedOptions = this.model.availableOptions;
    this.formGroup.controls["model"].setValue(this.model.availableOptions, {
      onlySelf: true,
      emitEvent: false,
    });

    this.segment.selectedOptions = this.segment.availableOptions;
    this.formGroup.controls["segment"].setValue(this.segment.availableOptions, {
      onlySelf: true,
      emitEvent: false,
    });

    this.propulsion.selectedOptions = this.propulsion.availableOptions;
    this.formGroup.controls["propulsion"].setValue(
      this.propulsion.availableOptions,
      { onlySelf: true, emitEvent: false }
    );

    this.market.selectedOptions = this.market.availableOptions;
    this.formGroup.controls["market"].setValue(this.market.availableOptions, {
      onlySelf: true,
      emitEvent: false,
    });
  }

  public onChange($event): void {
    if ($event.checked === true) {
      this.selectDefaultYearRange();
      this.selectAllMenuOptions().then(() => {
        this.endLoading();
        this.cd.detectChanges();
      });
    } else {
      this.selectAllReportFilters = false;
    }
    this.setSession(this.cplOem, JSON.stringify(this.oem.selectedOptions));
    this.setSession(this.cplBrand, JSON.stringify(this.brand.selectedOptions));
    this.setSession(this.cplModel, JSON.stringify(this.model.selectedOptions));
    this.setSession(
      this.cplSegment,
      JSON.stringify(this.segment.selectedOptions)
    );
    this.setSession(
      this.cplPropulsion,
      JSON.stringify(this.propulsion.selectedOptions)
    );
    this.setSession(
      this.cplMarket,
      JSON.stringify(this.market.selectedOptions)
    );
  }

  public populateChangeDetailsFilters(data): void {
    this.changeTypes.availableOptions = Object.keys(data.changes[0]);
    this.changeTypes.model.setValue(this.changeTypes.availableOptions, {
      onlySelf: true,
      emitEvent: false,
      emitModelToViewChange: true,
      emitViewToModelChange: false,
    });
    this.changeTypes.selectedOptions = this.changeTypes.availableOptions;

    this.changeSegments.availableOptions = Object.keys(data.globalSegments[0]);
    this.changeSegments.model.setValue(this.changeSegments.availableOptions, {
      onlySelf: true,
      emitEvent: false,
      emitModelToViewChange: true,
      emitViewToModelChange: false,
    });
    this.changeSegments.selectedOptions = this.changeSegments.availableOptions;
  }

  public parseDate(date: UntypedFormControl): string {
    return date.value.toLocaleDateString().split("/").join("-");
  }

  public getYearOptions(): Observable<any> {
    const url = environment.serviceURL + "/competitiveLandscapeAvailableYears";
    return this.http.get<any>(url);
  }

  public selectDefaultYearRange(): void {
    if (this.startDate.model.valid) {
      let curYear: number;
      if (
        this.startDate.model.value === "Invalid Date" ||
        !this.startDate.model.value
      ) {
        const currentDate = new Date();
        curYear = currentDate.getFullYear();
      } else {
        curYear = this.startDate.model.value.getFullYear();
      }
      const yearRange = [];
      for (let i = curYear; i < curYear + 10; i++) {
        yearRange.push(i.toString());
      }
      this.displayYears.selectedOptions = yearRange;
      this.displayYears.model.setValue(this.displayYears.selectedOptions, {
        onlySelf: true,
        emitEvent: true,
        emitModelToViewChange: true,
        emitViewToModelChange: false,
      });
    }
  }

  public setAvailableYearOptions(): void {
    const updatedYears = [];
    this.getYearOptions().subscribe((x) => {
      this.displayYears.availableOptions = x;
      this.displayYears.availableOptions.forEach((yr) => {
        if (isDate(this.startDate.model.value)) {
          if (yr >= this.startDate.model.value.getFullYear()) {
            updatedYears.push(yr);
          }
        }
      });
      this.displayYears.availableOptions = updatedYears;
    });
  }

  public setupDataforChangeDetailsTable(): void {
    this.filteredVehicleRolloutList = this.vehicleRolloutList.filter(
      (veh) =>
        this.changeTypes.selectedOptions.includes(veh.FLAG) &&
        this.changeSegments.selectedOptions.includes(veh.s_globalsegment)
    );
    const tempFiltered = [];
    this.filteredVehicleRolloutList.forEach((veh) => {
      Object.entries(veh.s_cycles).forEach((cycle) => {
        (this.displayYears.selectedOptions as any[]).forEach((yr) => {
          if (cycle[0] === yr) {
            if (
              this.cycleOptions.some((v) => cycle[1].toString().includes(v))
            ) {
              tempFiltered.push(veh);
            }
          }
        });
      });
    });
    this.filteredVehicleRolloutList = tempFiltered;
  }

  public getAvailableOptions(menu: Menu): any[] {
    return menu.availableOptions;
  }
}
